import type { ActivityKind, ActivityPeriod } from './activityTypes';

export const dashboardPath = (): string => '/dashboard';

export const dashboardActivityPath = (
  kind: ActivityKind,
  period: ActivityPeriod | 'all' = 'all',
): string =>
  period === 'all'
    ? `/dashboard/${kind}`
    : `/dashboard/${kind}?period=${period}`;
